import React, { useState } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import InfiniteScroll from 'react-infinite-scroller';

import BlogPostListItem from './blog_post_list_item';

const BlogPostList = (props) => {
  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const loadNextPage = () => {
    const nextChunk = props.data.allStoryblokEntry.edges.slice(
      pageNumber * 10,
      (pageNumber + 1) * 10
    );
    setItems([].concat(items).concat(nextChunk));
    setPageNumber(pageNumber + 1);
  };

  return (
    <InfiniteScroll
      pageStart={0}
      loadMore={loadNextPage}
      hasMore={items.length < props.data.allStoryblokEntry.edges.length}
    >
      {items.map((entry, idx) => (
        <BlogPostListItem key={`post-${idx}`} item={entry.node} />
      ))}
    </InfiniteScroll>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        allStoryblokEntry(
          filter: { field_component: { eq: "blog_post" } }
          sort: { fields: first_published_at, order: DESC }
        ) {
          edges {
            node {
              id
              name
              full_slug
              first_published_at
              field_intro_string
              field_author_string
              field_category_string
              content
            }
          }
        }
      }
    `}
    render={(data) => <BlogPostList data={data} {...props} />}
  />
);
